import useDashboardRecentActivity from './useDashboardRecentActivity'

export default useDashboardRecentActivity
